module.exports = __webpack_public_path__ + "media/images/Hortense-voyage-sur-mesure-93752e2da44cb15db68257903fcb87d4.gif";